module.exports = __webpack_public_path__ + "static/img/zn.119a6be5.png";